import Vue from 'vue';
import App from '@/App.vue';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';

import { preventTwoFinger, preventDoubleTap } from '@/common/util/control';

// スマホ操作制御
preventTwoFinger();
preventDoubleTap();

Vue.config.productionTip = false;

// const messages = {
//   en: {
//     message: {
//       カード: 'card',
//     },
//   },
//   ja: {
//     message: {
//       カード: 'カード',
//     },
//   },
// };

// const i18n = new VueI18n({
//   locale: 'ja',
//   messages,
// });

new Vue({
  router,
  store,
  vuetify,
  // i18n,
  render: (h) => h(App),
}).$mount('#app');
